'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getType = exports.getId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getId = exports.getId = (0, _getIn2.default)(['senderId']);
var getType = exports.getType = (0, _getIn2.default)(['senderType']);